import { getGoods } from "../../js/axios";
import el from "element-ui/src/locale/lang/el";
import axios from 'axios'  //这里引入axios  mian无需再引
import Vue from "vue";    //引入Vue
Vue.prototype.$ajax = axios;  //修改ajax原型指向为 axios
import Qs from 'qs';
export default {
    name: 'goods',
    data() {
        var packageVerify = (rule, value, callback) => {
        	if(this.formData.goods_ids.length <= 0) {
        		callback(new Error('請選擇使用產品'));
        	} else {
        		callback();
        	}
        	// callback();
        }
        return {
        	submiting: false, // 正在请求
        	list: [], //列表
        	pager: {
        		count: 0, // 总条数
        		page: 1, // 当前页
        		pagecount: 0, // 总页数
        		pagesize: 10 // 每页条数
        	},
        	isAlert: false,
        	oper: '',
        	formData: {
        		name: '',
        		cost_price: '',
        		price: '',
        		blood_price: '',
        		sort: 100,
        		custom: '',
				type: '',
        		status: true,
        	},
        	rules: {
        		name: [
        			{ required: true, message: '請輸入名稱', trigger: 'blur' }
        		],
        		cost_price: [
        			{ required: true, message: '請輸入市場價格', trigger: 'blur' }
        		],
        		price: [
        			{ required: true, message: '請輸入價格', trigger: 'blur' }
        			// { validator: packageVerify, trigger: 'change' }
        		],
        		blood_price: [
        			{ required: false, message: '請輸入驗血價格', trigger: 'blur' }
        		],
				type: [
					{ required: true, message: '請輸入代號', trigger: 'blur' }
				],
        		sort: [
        			{ required: false, message: '請輸入排序', trigger: 'blur' }
        		],
        		status: [
        			{ required: false, message: '請選擇啟用狀態', trigger: 'change' }
        		],
        	},
        	rules1: {
        		name: [
        			{ required: true, message: '請輸入名稱', trigger: 'blur' }
        		],
        		price: [
        			{ required: true, message: '請輸入價格', trigger: 'blur' }
        			// { validator: packageVerify, trigger: 'change' }
        		],
        	},
        	custom: '',
        	base: {},
        	mlev: {},
        	packageA: {},
        	packageB: {},
        	packageC: {},
        	packageD: {},
        	packageFB: {},
		}
    },

    mounted() {
		this.getList()
    },
    methods: {
		resetPager(){
			this.pager = {
        		count: 0, // 总条数
        		page: 1, // 当前页
        		pagecount: 0, // 总页数
        		pagesize: 10 // 每页条数
        	}	
		},
       handleStatus(val) {
       	getGoods({act: 'status', id: val.id, status: val.status}).then((res) => {
       		if(res.code == 200) {
       			this.getList();
       		} else {
       			this.$myAlert({
       				type: 'fail',
       				title: res.msg
       			});
       		}
       	})
       },
       // 获取列表
       getList() {
       	getGoods(this.pager).then(res => {
       		if(res.code == 200){
       			this.list = res.data.data;
       			this.pager = res.data.pager;
       			this.list.map((item) => {
       				
       			})
       			// 数值可能为字符串，需转换为number
       			for(var key in this.pager){
       				this.pager[key] = parseInt(this.pager[key]);
       			}
       			
       		}else{
				this.resetPager()
       			this.$myAlert({
       				type: 'fail',
       				title: res.msg
       			});
       		}
       	});
       },
       pageChange(page) {
       	this.pager.page = page;
       	this.getList();
       },
       
       showDialog(oper, id) {
       	this.oper = oper;
       	this.isAlert = true;
       	if(oper == 'update') {
       		getGoods({act: 'detail', id: id}).then((res) => {
       			if(res.code == 200) {
       				this.formData = {
       					id: res.data.id,
       					name: res.data.name,
       					cost_price: res.data.cost_price,
       					custom: res.data.custom ? {...res.data.custom} : '',
       					price: res.data.price,
       					blood_price: res.data.blood_price,
       					sort: res.data.sort,
						type: res.data.type,
       					status: res.data.status == 1 ? true : false,
       				}
       				if(res.data.custom) {
       					this.custom = res.data.custom
       					this.base = res.data.custom.base
       					this.mlev = res.data.custom.mlev
       					this.packageA = res.data.custom.packageA
       					this.packageB = res.data.custom.packageB
       					this.packageC = res.data.custom.packageC
       					this.packageD = res.data.custom.packageD
       					this.packageFB = res.data.custom.packageFB
       				} else {
       					this.custom = ''
       				}
       				// if(res.data.custom) {
       				// 	let customList = [];
       				// 	let obj1 = Object.keys(res.data.custom);
       				// 		obj1.forEach((key) => {
       				// 			customList.push({[key]:res.data.custom[key]})
       				// 			// console.log(key, res.data.custom[key]);
       				// 		});
       						
       				// 		this.customList = customList;
       				// 	console.log(customList)
       				// }
       				
       			
       			} else {
       				this.$myAlert({
       					type: 'fail',
       					title: res.msg
       				});
       			}
       		})
       	} else {
       		this.custom = {};
       	}
       	
       },
       formSubmit() {
       	if(this.oper == 'update') {
       		this.$refs.form.validate(isSuc => {
       			if(isSuc){
       				let data = {...this.formData};
       				data.act = 'update';
       				data.status = data.status ? '1' : '0';
       				
       				if(!this.custom) {
       					delete data.custom
       				}
       				
       				getGoods(data).then((res) => {
       					if(res.code == 200) {
       						this.isAlert = false;
       						this.formData = {};
       						this.$myAlert({
       							type: 'success',
       							title: (this.oper == 'add'?'添加':'修改')+'成功'
       						});
       						this.getList();
       					} else {
       						this.$myAlert({
       							type: 'fail',
       							title: res.msg
       						});
       					}
       				})
       				
       				
       			}
       		
       		})
       	} else if(this.oper == 'add') {
       		this.$refs.form.validate(isSuc => {
       			if(isSuc){
       				let data = {...this.formData};
       				data.act = 'add';
       				data.status = data.status ? '1' : '0';
       				
       				if(!this.custom) {
       					delete data.custom
       				}
       				
       				getGoods(data).then((res) => {
       					if(res.code == 200) {
       						this.isAlert = false;
       						this.formData = {};
       						this.$myAlert({
       							type: 'success',
       							title: (this.oper == 'add'?'添加':'修改')+'成功'
       						});
       						this.getList();
       					} else {
       						this.$myAlert({
       							type: 'fail',
       							title: res.msg
       						});
       					}
       				})
       				
       				
       			}
       		
       		})
       	}
       	
       },
       formCancel() {
       	this.$refs.form.resetFields();
       	this.noTimes = false;
       	this.isAlert = false;
       },
    }
}